/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useReducer, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withTranslation, useTranslation } from 'react-i18next';
import { filter, find, isArray, isEqual } from 'lodash';

import {
  Grid,
  Radio,
  Icon,
  Divider,
  Accordion,
  Checkbox,
  Label,
  Form,
} from 'semantic-ui-react';

import { isEmpty, get, debounce } from '../../utils/lodash';

import {
  getOrganizationReportData,
  getProgrammeReportData,
  advancedFilterReset,
  getCrossReferenceByGoal,
  advancedFilterAllReset,
  getDepartmentLabels,
  getDepartmentHierarchy,
  setSidebarType,
} from '../../store/actions';

import { REPORT_FILTER_OPTIONS, SIDEBAR_TYPES } from '../../utils/constant';

import './AdvancedActivityFilter.scss';

const ACTIVE_PARTICIPANTS_LIST = (t) => [
  {
    id: 5,
    key: 5,
    text: t('sidebar.constants.activeParticipants.free'),
    checked: false,
  },
  {
    id: 6,
    key: 6,
    text: t('sidebar.constants.activeParticipants.paying'),
    checked: false,
  },
  {
    id: 7,
    key: 7,
    text: t('sidebar.constants.activeParticipants.paid'),
    checked: false,
  },
];

const ACTIVITY_STATE_LIST = (t) => [
  {
    id: 1,
    key: 1,
    text: t('activity_status.in_development'),
    checked: false,
  },
  {
    id: 2,
    key: 2,
    text: t('activity_status.active'),
    checked: false,
  },
  {
    id: 3,
    key: 3,
    text: t('activity_status.completed'),
    checked: false,
  },
];

const ORG_LEVEL_LIST = (t) => [
  {
    id: 1,
    key: 'all',
    value: 'all',
    text: t('common.all'),
    checked: true,
  },
  {
    id: 2,
    key: 'internal',
    value: 'internal',
    text: t('sidebar.constants.organizationLevel.internal'),
    checked: false,
  },
  {
    id: 3,
    key: 'external',
    value: 'external',
    text: t('sidebar.constants.organizationLevel.external'),
    checked: false,
  },
];

const ACTIVITY_TYPE_LIST = (t) => [
  {
    id: 1,
    key: 1,
    text: t('sidebar.constants.activityType.singleActivity'),
    checked: false,
  },
  {
    id: 3,
    key: 3,
    text: t('sidebar.constants.activityType.festivalProgram'),
    checked: false,
  },
  {
    id: 4,
    key: 4,
    text: t('sidebar.constants.activityType.grantProgram'),
    checked: false,
  },
  {
    id: 6,
    key: 6,
    text: t('sidebar.constants.activityType.multiActivityProgram'),
    checked: false,
  },
];

const RECEPTIVE_PARTICIPANTS_LIST = (t) => [
  {
    id: 3,
    key: 3,
    text: t('sidebar.constants.receptiveParticipants.free'),
    checked: false,
  },
  {
    id: 4,
    key: 4,
    text: t('sidebar.constants.receptiveParticipants.paying'),
    checked: false,
  },
];

const ReportFilter = ({
  dataset,
  parentStateHandler = null,
  horizontal = true,
  toggle = true,
  reportType,
  toggleDefaultValue = false,
  setToggleDefaultValue = null,
}) => {
  const { t } = useTranslation();
  const reportFilterOptions = useSelector(
    (state) => state.report.reportFilterOptions
  );
  const [activityStatus, setActivityStatus] = useState([]);
  const [isToggle, setIsToggle] = useState(toggleDefaultValue);

  useEffect(() => {
    !isEqual(dataset, activityStatus) && setActivityStatus(dataset);
  }, [dataset]);

  useEffect(() => {
    if (reportFilterOptions.statuses.length === 0) {
      setIsToggle(false);
    }
  }, [reportFilterOptions]);

  useEffect(() => {
    setToggleDefaultValue && setToggleDefaultValue(isToggle);
  }, [isToggle]);

  useEffect(() => {
    setIsToggle(toggleDefaultValue);
  }, [toggleDefaultValue]);

  const toggleOnOff = () => {
    if (isToggle) {
      setActivityStatus((prevData) =>
        prevData.map((item) => {
          return { ...item, checked: false };
        })
      );
      setIsToggle(false);
    } else {
      setIsToggle(true);
    }
    const value = activityStatus.map((item) => {
      return { ...item, checked: isToggle ? false : true };
    });
    parentStateHandler(value);
  };

  const handleActivityStatus = (checked, key) => {
    let value = [];
    value = activityStatus.map((item) => {
      if (item.key === key)
        return { ...item, checked: item.checked ? false : true };
      return item;
    });
    parentStateHandler(value);
  };

  return (
    <div
      className={
        horizontal ? 'filter-components-column' : 'filter-components-row'
      }
    >
      {(reportType === 'activities' ||
        reportType === 'outcomes-addressed' ||
        isEmpty(reportType)) &&
        toggle && (
          <div className="two-step-radio-container-admin">
            <Radio
              toggle
              name="activateToggel"
              label={t('sidebar.advanced_filter.groupByStatus')}
              onChange={() => toggleOnOff()}
              checked={reportFilterOptions.statuses.length > 0}
            />
          </div>
        )}

      {activityStatus &&
        activityStatus.map((item, key) => {
          return (
            <Grid.Column className="grid-column" key={`filter_status_${key}`}>
              <Checkbox
                className="check-box"
                label={item.text}
                checked={get(item, 'checked', false)}
                onChange={(e, { checked }) =>
                  handleActivityStatus(checked, item.id)
                }
                disabled={
                  reportType === 'activities' ||
                  reportType === 'outcomes-addressed'
                    ? !isToggle
                    : false
                }
              />
            </Grid.Column>
          );
        })}
    </div>
  );
};

const RadioGroup = ({
  dataset,
  parentStateHandler,
  // hideShowMore = true,
}) => {
  // const [showMore, setShowMore] = useState(false);
  const [optionArray, setOptionArray] = useState([]);

  useEffect(() => {
    !isEqual(dataset, optionArray) && setOptionArray(dataset);
  }, [dataset]);

  const handleChange = (e, { value }) => {
    let val = optionArray.map((item) => {
      if (item.value === value)
        return { ...item, checked: item.checked ? false : true };
      else {
        return { ...item, checked: false };
      }
    });
    setOptionArray(val);
    parentStateHandler(val);
  };

  return (
    <div>
      <Form.Group>
        {optionArray.map((item, key) => (
          <Form.Radio
            key={`filter_radio_group_show_more_${key}`}
            label={item.text}
            value={item.value}
            checked={get(item, 'checked', false)}
            onChange={handleChange}
          />
        ))}
      </Form.Group>
      {/* {hideShowMore ? (
        <div className="show-all-button">
          <p
            onClick={() => {
              showMore ? setShowMore(false) : setShowMore(true);
            }}
          >
            {showMore ? 'Show Less' : ' Show all'}
            <Icon className="ml-1" name="chevron down" />
          </p>
        </div>
      ) : null} */}
    </div>
  );
};

////////////////////////////////////////////////////////////
// own internal state + reducer to manage filtering options

const initialState = {
  usedDataOnly: false,
  organizationLevelOptions: [],
  outcomeOptions: [],
  outcomeOption: [],
  methodOptions: [],
  venueOptions: [],
  activityStatusOptions: [],
  activityTypeOptions: [],
  receptiveParticipantsOptions: [],
  activeParticipantsOptions: [],
  goalsOptions: [],
  crossReferenceOptions: [],
  departmentHierarchyOptions: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'OrganizationLevel':
      return {
        ...state,
        organizationLevelOptions: action.payload,
      };
    case 'UsedDataOnly':
      return {
        ...state,
        usedDataOnly: action.payload,
      };
    case 'Outcomes':
      return {
        ...state,
        outcomeOptions: action.payload,
      };
    case 'Outcome':
      return {
        ...state,
        outcomeOption: action.payload,
      };
    case 'Methods':
      return {
        ...state,
        methodOptions: action.payload,
      };
    case 'Venues':
      return {
        ...state,
        venueOptions: action.payload,
      };
    case 'SubVenues':
      return {
        ...state,
        subVenueOptions: action.payload,
      };

    case 'ActivityStatus':
      return {
        ...state,
        activityStatusOptions: action.payload,
      };

    case 'Activity':
      return {
        ...state,
        activityTypeOptions: action.payload,
      };

    case 'ReceptiveParticipants':
      return {
        ...state,
        receptiveParticipantsOptions: action.payload,
      };

    case 'ActiveParticipants':
      return {
        ...state,
        activeParticipantsOptions: action.payload,
      };

    case 'Goals':
      return {
        ...state,
        goalsOptions: action.payload,
      };

    case 'CrossReference':
      return {
        ...state,
        crossReferenceOptions: action.payload,
      };

    case 'DepartmentHierarchy':
      return {
        ...state,
        departmentHierarchyOptions: action.payload,
      };

    default:
      throw new Error(`Unsupported action type: ${action.type}`);
  }
};

const AdvancedActivityFilter = (props) => {
  const { t } = useTranslation();
  const prevProps = useRef();

  const dispatch = useDispatch();

  const [state, stateDispatch] = useReducer(reducer, initialState);

  const [toggleDefaultValue, setToggleDefaultValue] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const outcomes = useSelector((state) => state.extra.outcomes);
  const methods = useSelector((state) => state.extra.methods);
  const orgVenueTypes = useSelector((state) => state.extra.orgVenueTypes);

  const departmentLabels = useSelector(
    (state) => state.organization.deptLabels
  );
  const departmentHierarchy = useSelector(
    (state) => state.organization.deptHierarchy
  );

  const outcomeSummaryGoals = useSelector(
    (state) => state.organization.organisationGoals
  );

  const currentActivity = useSelector(
    (state) => state.activity.currentActivity
  );

  const isAdvancedFilter =
    useSelector((state) => state.sidebar.sideBarType) === SIDEBAR_TYPES[2];

  const isVisibleSidebar = useSelector(
    (state) => state.sidebar.isVisibleSidebar
  );
  const advancedToggle = isAdvancedFilter && isVisibleSidebar;

  const isOutcomeReportedPage = useSelector(
    (state) => state.report.isOutcomeReportedPage
  );
  const filterCrossReferences = useSelector(
    (state) => state.report.filterCrossReferences
  );
  const reportFilter = useSelector((state) => state.report.reportFilterOptions);
  const parentReportType = useSelector(
    (state) => state.report.parentReportType
  );

  let REPORT_TYPE = props.isProgram
    ? parentReportType
    : props.match.params.type;

  if (isOutcomeReportedPage) {
    REPORT_TYPE = 'outcomes-reported';
  }

  // to check if path changed
  useEffect(() => {
    if (prevProps.path !== props.match.path) {
      clearAll(false);
      setActiveIndex(0);
    }
    prevProps.path = props.match.path;
  }, [props.match.path]);

  // to check if activity path changed (not program report available)
  useEffect(() => {
    if (
      props.match.path === '/activities/:id/:type' &&
      props.match.params.type !== 'documentation'
    ) {
      clearAll(false);
      setActiveIndex(0);
    }
  }, [props.match.pathname]);

  useEffect(() => {
    if (reportFilter.method === 'all') {
      initMethodOptions();
    }
  }, [reportFilter.method]);

  useEffect(() => {
    stateDispatch({
      type: 'ActivityStatus',
      payload: ACTIVITY_STATE_LIST(t),
    });

    stateDispatch({
      type: 'OrganizationLevel',
      payload: ORG_LEVEL_LIST(t),
    });

    stateDispatch({
      type: 'Activity',
      payload: ACTIVITY_TYPE_LIST(t),
    });

    stateDispatch({
      type: 'ReceptiveParticipants',
      payload: RECEPTIVE_PARTICIPANTS_LIST(t),
    });

    stateDispatch({
      type: 'ActiveParticipants',
      payload: ACTIVE_PARTICIPANTS_LIST(t),
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      advancedToggle && scrollToId();
    }, 500);
  }, []);

  useEffect(() => {
    dispatch(getDepartmentLabels());
    dispatch(getDepartmentHierarchy());
  }, []);

  useEffect(() => {
    initOutcomesOptions();
  }, [outcomes]);

  useEffect(() => {
    initSingleOutcomeOption();
  }, [reportFilter]);

  useEffect(() => {
    initMethodOptions();
  }, [methods]);

  useEffect(() => {
    initGoalOptions();
  }, [outcomeSummaryGoals]);

  useEffect(() => {
    initVenueOptions();
  }, [orgVenueTypes]);

  useEffect(() => {
    initDepartmentHierarchyOptions();
  }, [departmentHierarchy]);

  useEffect(() => {
    initReferenceOptions();
  }, [filterCrossReferences]);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const resetSubOptions = (subItems, parentKey) => {
    return subItems.map((val) => {
      if (parentKey === val.parentVenueId) {
        return {
          ...val,
          checked: false,
        };
      } else {
        return val;
      }
    });
  };

  const handleVenueChange = async (checked, key) => {
    let value = [];
    value = state.venueOptions.map((item) => {
      const subItems = filter(
        item.subItems,
        (sub) => sub.parentVenueId === item.key
      );
      if (!checked && !isEmpty(subItems)) {
        //if parent unchecked the box, child will be reset
        item.subItems = resetSubOptions(subItems, key);
      }
      const getSubItem = find(subItems, (val) => val.key === key);
      if (getSubItem) {
        //child items
        getSubItem.checked = getSubItem.checked ? false : true;
        const uniqueSubItems = new Set([...item.subItems, getSubItem]);
        item.subItems = Array.from(uniqueSubItems);
      }
      if (item.key === key)
        //parent items
        return { ...item, checked: item.checked ? false : true };
      return item;
    });

    handleFilterChange({
      venues: getStateParentValue(value),
      subVenues: getStateIds(value).subOptionIds,
    });

    stateDispatch({
      type: 'Venues',
      payload: value,
    });
  };

  const handleBulkUpdate = (array, selectedItem) => {
    const updatedArray = array.map((item) => {
      if (isArray(selectedItem)) {
        if (selectedItem.includes(item.key)) {
          return { ...item, checked: true };
        }
      } else {
        if (selectedItem === item.key) {
          return { ...item, checked: true };
        }
      }
      return item;
    });
    return updatedArray;
  };

  const handleFilterChange = (filterObj, event = null) => {
    event?.stopPropagation();

    filterObj.page = 1;
    if (props.isProgram) {
      dispatch(
        debounce(
          getProgrammeReportData(parentReportType, props.projectId, filterObj),
          1000,
          { leading: true }
        )
      );
    } else {
      dispatch(
        debounce(getOrganizationReportData(REPORT_TYPE, filterObj), 1000, {
          leading: true,
        })
      );
    }
  };

  ////////////////////////////////////////////////////////////
  // "init options" helpers - these turn the "raw" data into
  // option structures we use in our local state

  const initOutcomesOptions = () => {
    const { isProgram } = props;
    const outcomesOptions = [];

    if (isProgram) {
      const { parentOutcomes = null } = currentActivity;
      if (parentOutcomes) {
        const parentOutcomesIds = parentOutcomes.map((item) => item.outcomeId);

        outcomes.forEach((outcome) => {
          if (parentOutcomesIds.includes(outcome.id))
            outcomesOptions.push({
              key: outcome.id,
              text: outcome.title,
              value: outcome.id,
              checked: false,
              prePost: outcome.prePost,
            });
        });
      }
    } else {
      if (!isEmpty(outcomes)) {
        outcomes.forEach((outcome) =>
          outcomesOptions.push({
            key: outcome.id,
            text: outcome.title,
            value: outcome.id,
            checked: false,
            prePost: outcome.prePost,
          })
        );
      }
    }

    stateDispatch({
      type: 'Outcomes',
      payload:
        !isEmpty(reportFilter.outcomes) || !isArray(reportFilter.outcomes)
          ? handleBulkUpdate(outcomesOptions, reportFilter.outcomes)
          : outcomesOptions,
    });
  };

  const initSingleOutcomeOption = () => {
    const outcomesOption = [];

    const updatedOptions = outcomes.map((outcome) => {
      const option = {
        key: outcome.id,
        text: outcome.title,
        value: outcome.id,
        checked: false,
        prePost: outcome.prePost,
      };

      if (option.value === reportFilter.outcome) {
        option.checked = true;
      }

      return option;
    });

    outcomesOption.push(...updatedOptions);

    stateDispatch({
      type: 'Outcome',
      payload: outcomesOption,
    });
  };

  const initMethodOptions = () => {
    const methodOptions = [];
    if (!isEmpty(methods)) {
      methods.map((method, i) =>
        methodOptions.push({
          key: method.id,
          text: method.details,
          value: method.id,
          checked: false,
        })
      );

      const optionAll = [
        { key: 'all', text: t('common.all'), value: 'all', checked: true },
      ];

      stateDispatch({
        type: 'Methods',
        payload: optionAll.concat(methodOptions),
      });
    }
  };

  const initVenueOptions = () => {
    const venueOptions = [];
    if (!isEmpty(orgVenueTypes)) {
      orgVenueTypes.map((venue) =>
        venueOptions.push({
          key: venue.id,
          text: venue.name,
          value: venue.id,
          checked: false,
          subItems: venue.venueSubOptions.map((item) => {
            return {
              key: `subItem_${item.id}`,
              text: item.name,
              value: item.id,
              checked: false,
              parentVenueId: venue.id,
            };
          }),
        })
      );

      stateDispatch({
        type: 'Venues',
        payload: venueOptions,
      });
    }
  };

  const initGoalOptions = () => {
    const goalOptions = [];
    if (!isEmpty(outcomeSummaryGoals)) {
      outcomeSummaryGoals.map((goal) =>
        goalOptions.push({
          key: goal.id,
          text: goal.goalTitle,
          value: goal.id,
          checked: false,
        })
      );

      stateDispatch({
        type: 'Goals',
        payload: goalOptions,
      });
    }
  };

  const initReferenceOptions = () => {
    const crossReferenceOptions = [];
    if (!isEmpty(filterCrossReferences)) {
      filterCrossReferences.map((xref) =>
        crossReferenceOptions.push({
          key: xref.id,
          text: xref.title,
          value: xref.id,
          checked: false,
        })
      );

      stateDispatch({
        type: 'CrossReference',
        payload: crossReferenceOptions,
      });
    }
  };

  const initDepartmentHierarchyOptions = () => {
    const departmentHierarchyOptions = [];
    if (!isEmpty(departmentHierarchy)) {
      const processDept = (dept) => {
        departmentHierarchyOptions.push({
          key: dept.id,
          text: dept.name,
          value: dept.id,
          level: dept.level,
          ancestorIds: dept.ancestorIds,
          checked: false,
        });
        dept.children?.forEach((child) => processDept(child));
      };
      departmentHierarchy.forEach((dept) => processDept(dept));

      // TODO:dbg
      console.info('************************* HEY HO');
      console.dir(departmentHierarchyOptions, { depth: 5 });

      stateDispatch({
        type: 'DepartmentHierarchy',
        payload: departmentHierarchyOptions,
      });
    }
  };

  ////////////////////////////////////////////////////////////
  // clear/reset options

  const clearAll = (callRequest = true) => {
    const isProgramReport = props.isProgram;
    filterReset(state.activityTypeOptions, 'Activity');
    filterReset(state.activityStatusOptions, 'ActivityStatus');
    filterReset(state.goalsOptions, 'Goals');
    filterReset(state.venueOptions, 'Venues');
    // filterReset(state.subVenueOptions, 'SubVenues');
    filterReset(state.outcomeOptions, 'Outcomes');
    filterReset(state.crossReferenceOptions, 'CrossReference');
    filterReset(state.departmentHierarchyOptions, 'DepartmentHierarchy');
    filterReset(state.methodOptions, 'Methods');
    filterReset(state.receptiveParticipantsOptions, 'ReceptiveParticipants');
    filterReset(state.activeParticipantsOptions, 'ActiveParticipants');
    filterReset(state.organizationLevelOptions, 'OrganizationLevel');

    // filterReset(state.usedDataOnly, 'UsedDataOnly');

    stateDispatch({
      type: 'UsedDataOnly',
      payload: REPORT_FILTER_OPTIONS.usedDataOnly,
    });

    dispatch(
      advancedFilterAllReset(
        REPORT_TYPE,
        isProgramReport,
        props.projectId,
        callRequest
      )
    );
    setToggleDefaultValue(false);
  };

  const filterReset = (values, type, event = null) => {
    try {
      event?.stopPropagation();

      if (!values) {
        return;
      }

      if (type === 'ActivityStatus') {
        const updatedArray = values.map((item) => {
          return { ...item, checked: false };
        });

        stateDispatch({
          type: type,
          payload: updatedArray,
        });
      } else if (type === 'OrganizationLevel') {
        const updatedArray = values.map((item) => {
          return { ...item, checked: item.value === 'all' };
        });
        stateDispatch({
          type: type,
          payload: updatedArray,
        });
      } else {
        const updatedArray = values.map((item) => {
          if (!isEmpty(item.subItems)) {
            item.subItems = item.subItems.map((sub) => {
              return { ...sub, checked: false };
            });
          }
          return { ...item, checked: false };
        });
        stateDispatch({
          type: type,
          payload: updatedArray,
        });
      }
    } catch (err) {
      console.error('filterReset err: ', err);
    }
  };

  ////////////////////////////////////////////////////////////
  // selected ID/key helpers

  function getStateIds(stateValues) {
    const keysArray = [];
    const subsArray = [];

    stateValues.forEach((data) => {
      if (data.checked) {
        keysArray.push(data.key);
      }
      if (data.subItems) {
        data.subItems.forEach(
          (item) => item.checked && subsArray.push(item.key)
        );
      }
    });

    const updatedSubsArray = subsArray.map((item) =>
      parseInt(item.replace('subItem_', ''), 10)
    );

    return { parentIds: keysArray, subOptionIds: updatedSubsArray };
  }

  const getStateParentValue = (value, initValue = false) => {
    if (initValue) {
      const [item] = getStateIds(value).parentIds;
      return item;
    } else {
      return getStateIds(value).parentIds;
    }
  };

  ////////////////////////////////////////////////////////////
  // filter form handlers

  const onClearDepartmentHierarchy = (event = null) => {
    filterReset(state.departmentHierarchyOptions, 'DepartmentHierarchy', event);
    handleFilterChange({ departments: [] }, event);
  };

  const onClickDepartmentHierarchy = (item, checked, event = null) => {
    console.warn('******** MAP');
    console.dir(state.departmentHierarchyOptions, { depth: 5 });

    const newHierarchyOptions = state.departmentHierarchyOptions.map(
      (option) => {
        if (option.key === item.key) {
          return { ...option, checked };
        }
        if (option.ancestorIds.includes(item.key)) {
          return { ...option, checked };
        }
        return option;
      }
    );

    stateDispatch({
      type: 'DepartmentHierarchy',
      payload: newHierarchyOptions,
    });

    handleFilterChange({
      departments: getStateParentValue(newHierarchyOptions),
    });
  };

  ////////////////////////////////////////////////////////////
  // misc form DOM helpers

  const scrollToId = () => {
    document.getElementById('outcome-scroll') &&
      document.getElementById('outcome-scroll').scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
  };

  ////////////////////////////////////////////////////////////
  // maintain counts of various filter sets

  const activityTypeOptionsCount = getStateIds(state.activityTypeOptions)
    .parentIds.length;
  const activityStatusCount = getStateIds(state.activityStatusOptions).parentIds
    .length;
  const venueOptionsCount = getStateIds(state.venueOptions).parentIds.length;
  const receptiveParticipantsCount = getStateIds(
    state.receptiveParticipantsOptions
  ).parentIds.length;
  const activeParticipantsCount = getStateIds(state.activeParticipantsOptions)
    .parentIds.length;
  const crossReferenceOptionsCount = getStateIds(state.crossReferenceOptions)
    .parentIds.length;
  const departmentHierarchyOptionsCount = getStateIds(
    state.departmentHierarchyOptions
  ).parentIds.length;
  const outcomeOptionsCount = getStateIds(state.outcomeOptions).parentIds
    .length;
  const goalsOptionsCount = getStateIds(state.goalsOptions).parentIds.length;

  return (
    <div className="advance-filter">
      <div className="filter-header">
        <label className="filter-text">
          {t('sidebar.advanced_filter.filterBy')}
        </label>
        <div>
          {/* <label className="filter-save">Save</label> */}

          <label className="filter-reset" onClick={clearAll}>
            {t('actions.clear_all')}
          </label>

          <Icon
            name="close"
            className="info-close"
            onClick={() => {
              dispatch(setSidebarType(SIDEBAR_TYPES[2], false));
            }}
          />
        </div>
      </div>
      <div className="filter-body">
        <Accordion fluid>
          {REPORT_TYPE !== 'outcomes-reported' &&
            REPORT_TYPE !== 'input-output-data' && (
              <>
                <Accordion.Title
                  active={activeIndex === 0}
                  index={0}
                  className="accordion-title"
                  onClick={handleClick}
                >
                  <div className="btn-flex">
                    <label className="filter-label">{t('common.report')}</label>
                    <Icon
                      name="dropdown"
                      className="dropdown-advanced-filter"
                    />
                  </div>
                </Accordion.Title>
                <Accordion.Content
                  active={activeIndex === 0}
                  className="accordion-content"
                >
                  <div style={{ display: ' flex', flexDirection: 'row' }}>
                    <Checkbox
                      className="check-box"
                      label={t('sidebar.advanced_filter.usedData')}
                      checked={state.usedDataOnly}
                      onChange={(e, { checked }) => {
                        stateDispatch({
                          type: 'UsedDataOnly',
                          payload: checked,
                        });
                        handleFilterChange({
                          usedDataOnly: checked,
                        });
                      }}
                    />
                  </div>
                </Accordion.Content>
                <Divider className="divider-margin" />
              </>
            )}
          {REPORT_TYPE !== 'management-summary' && (
            <>
              <Accordion.Title
                active={activeIndex === 1}
                index={1}
                className="accordion-title"
                onClick={handleClick}
              >
                <div className="btn-flex">
                  <label className="filter-label">
                    {t('sidebar.advanced_filter.designation')}
                  </label>
                  <Icon name="dropdown" className="dropdown-advanced-filter" />
                </div>
              </Accordion.Title>
              <Accordion.Content
                active={activeIndex === 1}
                className="accordion-content"
              >
                <RadioGroup
                  dataset={state.organizationLevelOptions}
                  parentStateHandler={(value) => {
                    stateDispatch({
                      type: 'OrganizationLevel',
                      payload: value,
                    });
                    handleFilterChange({
                      organisationLevel: getStateParentValue(value).toString(),
                    });
                  }}
                  // hideShowMore={false}
                />
              </Accordion.Content>
              <Divider className="divider-margin" />
            </>
          )}
          {/* Activity Status */}
          {REPORT_TYPE !== 'outcomes-reported' && (
            <>
              <Accordion.Title
                active={activeIndex === 2}
                index={2}
                className="accordion-title"
                onClick={handleClick}
              >
                <div className="btn-flex">
                  <label className="filter-label">
                    {t('sidebar.advanced_filter.activityStatus')}
                  </label>
                  <div className="filter-reset-flex">
                    <div className="open-act-status">
                      {activeIndex === 2 && activityStatusCount !== 0 && (
                        <Label
                          horizontal
                          className="orange-reset"
                          onClick={(event) => {
                            filterReset(
                              state.activityStatusOptions,
                              'ActivityStatus',
                              event
                            );
                            handleFilterChange(
                              {
                                statuses: [],
                              },
                              event
                            );
                          }}
                        >
                          {t('actions.clear')}
                        </Label>
                      )}
                      <Label horizontal className="blue-label">
                        {activityStatusCount}
                      </Label>
                    </div>
                  </div>
                  <Icon name="dropdown" className="dropdown-advanced-filter" />
                </div>
              </Accordion.Title>
              <Accordion.Content
                active={activeIndex === 2}
                className="accordion-content"
              >
                <ReportFilter
                  toggleDefaultValue={toggleDefaultValue}
                  type="ACTIVITY_STATUS"
                  reportType={REPORT_TYPE}
                  dataset={state.activityStatusOptions}
                  setToggleDefaultValue={setToggleDefaultValue}
                  parentStateHandler={(value) => {
                    stateDispatch({
                      type: 'ActivityStatus',
                      payload: value,
                    });
                    handleFilterChange({
                      statuses: getStateParentValue(value),
                    });
                  }}
                />
              </Accordion.Content>
              <Divider className="divider-margin" />
            </>
          )}

          {/* Activity Type */}
          <Accordion.Title
            active={activeIndex === 3}
            index={3}
            className="accordion-title"
            onClick={handleClick}
          >
            <div className="btn-flex">
              <label className="filter-label">
                {t('sidebar.advanced_filter.record')}
              </label>
              <div className="filter-reset-flex">
                <div className="open-act-type">
                  {activeIndex === 3 && activityTypeOptionsCount !== 0 && (
                    <Label
                      horizontal
                      className="orange-reset"
                      onClick={(event) => {
                        filterReset(
                          state.activityTypeOptions,
                          'Activity',
                          event
                        );
                        handleFilterChange(
                          {
                            activityTypes: [],
                          },
                          event
                        );
                      }}
                    >
                      {t('actions.clear')}
                    </Label>
                  )}
                  <Label horizontal className="blue-label">
                    {/* Replace this with the actual count */}
                    {activityTypeOptionsCount}
                  </Label>
                </div>
              </div>
              <Icon name="dropdown" className="dropdown-advanced-filter" />
            </div>
          </Accordion.Title>
          <Accordion.Content
            active={activeIndex === 3}
            className="accordion-content"
          >
            <div>
              {state.activityTypeOptions.map((item, index) => (
                <div key={`activity_type_${index}`}>
                  <Checkbox
                    label={item.text}
                    className="check-box"
                    checked={item.checked}
                    onChange={(e, { checked }) => {
                      const newValue = state.activityTypeOptions.map(
                        (option) =>
                          option.key === item.key
                            ? { ...option, checked }
                            : option
                      );
                      stateDispatch({
                        type: 'Activity',
                        payload: newValue,
                      });
                      handleFilterChange({
                        activityTypes: getStateParentValue(newValue),
                      });
                    }}
                  />
                </div>
              ))}
            </div>
          </Accordion.Content>
          <Divider className="divider-margin" />
          <Accordion.Title
            active={activeIndex === 4}
            index={4}
            onClick={handleClick}
            className="accordion-title"
          >
            <div className="btn-flex">
              <label className="filter-label">
                {t('activity.activity_plan.activity_input.venue')}
              </label>
              <div className="filter-reset-flex">
                <div className="open-venue">
                  {activeIndex === 4 && venueOptionsCount !== 0 && (
                    <Label
                      horizontal
                      className="orange-reset"
                      onClick={(event) => {
                        filterReset(state.venueOptions, 'Venues', event);
                        handleFilterChange(
                          {
                            venues: [],
                          },
                          event
                        );
                      }}
                    >
                      {t('actions.clear')}
                    </Label>
                  )}
                  <Label horizontal className="blue-label">
                    {venueOptionsCount}
                  </Label>
                </div>
              </div>
              <Icon name="dropdown" className="dropdown-advanced-filter" />
            </div>
          </Accordion.Title>
          {!isEmpty(state.venueOptions) ? (
            <Accordion.Content
              active={activeIndex === 4}
              className="accordion-content"
            >
              <div>
                {state.venueOptions.map((item, index) => {
                  return (
                    <div key={`venue_option_${index}`}>
                      <Checkbox
                        label={item.text}
                        className="check-box"
                        checked={item.checked}
                        onChange={(e, { checked }) => {
                          // const newValue = state.venueOptions.map(option =>
                          //   option.key === item.key
                          //     ? { ...option, checked }
                          //     : option
                          // );
                          handleVenueChange(checked, item.key);
                        }}
                      />
                      <Grid.Column className="sub-option-check">
                        {item.subItems.forEach((sub, index) => {
                          if (
                            sub.parentVenueId === item.value &&
                            item.checked
                          ) {
                            return (
                              <div key={`department_option_${index}`}>
                                <Checkbox
                                  key={`subItem_${sub.key}`}
                                  className="check-box"
                                  label={sub.text}
                                  checked={get(sub, 'checked', false)}
                                  onChange={(e, { checked }) => {
                                    handleVenueChange(checked, sub.key);
                                  }}
                                />
                              </div>
                            );
                          }
                        })}
                      </Grid.Column>
                    </div>
                  );
                })}
              </div>
            </Accordion.Content>
          ) : (
            <Accordion.Content
              active={activeIndex === 4}
              className="accordion-content"
            >
              <div>
                <p>{t('sidebar.advanced_filter.noVenueFound')}</p>
              </div>
            </Accordion.Content>
          )}
          <Divider className="divider-margin" />
          <Accordion.Title
            active={activeIndex === 5}
            index={5}
            className="accordion-title"
            onClick={handleClick}
          >
            <div className="btn-flex">
              <label className="filter-label">{t('report.participants')}</label>
              <div className="filter-reset-flex">
                <div className="open-participant">
                  {activeIndex === 4 &&
                    receptiveParticipantsCount + activeParticipantsCount !==
                      0 && (
                      <Label
                        horizontal
                        className="orange-reset"
                        onClick={(event) => {
                          filterReset(
                            state.participantsOptions,
                            'Participants',
                            event
                          );
                          stateDispatch({
                            type: 'ReceptiveParticipants',
                            payload: state.receptiveParticipantsOptions.map(
                              (option) => ({ ...option, checked: false })
                            ),
                          });
                          stateDispatch({
                            type: 'ActiveParticipants',
                            payload: state.activeParticipantsOptions.map(
                              (option) => ({ ...option, checked: false })
                            ),
                          });
                          handleFilterChange(
                            {
                              participants: [],
                            },
                            event
                          );
                        }}
                      >
                        {t('actions.clear')}
                      </Label>
                    )}
                  <Label horizontal className="blue-label">
                    {receptiveParticipantsCount + activeParticipantsCount}
                  </Label>
                </div>
              </div>
              <Icon name="dropdown" className="dropdown-advanced-filter" />
            </div>
          </Accordion.Title>
          {!isEmpty(state.receptiveParticipantsOptions) ||
          !isEmpty(state.activeParticipantsOptions) ? (
            <Accordion.Content
              active={activeIndex === 5}
              className="accordion-content"
            >
              <label className="filter-label-co">
                {t('sidebar.advanced_filter.receptiveParticipants')}
              </label>
              <ReportFilter
                toggle={false}
                horizontal={false}
                dataset={state.receptiveParticipantsOptions}
                parentStateHandler={(value) => {
                  stateDispatch({
                    type: 'ReceptiveParticipants',
                    payload: value,
                  });
                  handleFilterChange({
                    participants: getStateIds(
                      state.activeParticipantsOptions
                    ).parentIds.concat(getStateParentValue(value)),
                  });
                }}
              />
              <label className="filter-label-co">
                {t('sidebar.advanced_filter.activeParticipants')}
              </label>
              <ReportFilter
                toggle={false}
                horizontal={false}
                dataset={state.activeParticipantsOptions}
                parentStateHandler={(value) => {
                  stateDispatch({
                    type: 'ActiveParticipants',
                    payload: value,
                  });
                  handleFilterChange({
                    participants: getStateIds(
                      state.receptiveParticipantsOptions
                    ).parentIds.concat(getStateParentValue(value)),
                  });
                }}
              />
            </Accordion.Content>
          ) : (
            <Accordion.Content
              active={activeIndex === 5}
              className="accordion-content"
            >
              <div>
                <p>{t('sidebar.advanced_filter.noParticipantsFound')}</p>
              </div>
            </Accordion.Content>
          )}
          <Divider className="divider-margin" />
          <Accordion.Title
            className="accordion-title"
            active={activeIndex === 6}
            index={6}
            onClick={handleClick}
          >
            {/* <div className="btn-flex">
              <label className="filter-label">Outcomes</label>
              <Icon name="dropdown" />
            </div> */}
            <div className="btn-flex">
              <label className="filter-label">{t('common.outcomes')}</label>
              <div className="filter-reset-flex">
                <div className="open-outcomes">
                  {REPORT_TYPE !== 'outcomes-reported' &&
                  activeIndex === 6 &&
                  outcomeOptionsCount ? (
                    <Label
                      horizontal
                      className="orange-reset"
                      onClick={(event) => {
                        filterReset(state.outcomeOption, 'Outcomes', event);
                        handleFilterChange(
                          {
                            outcomes: [],
                          },
                          event
                        );
                      }}
                    >
                      {t('actions.clear')}
                    </Label>
                  ) : null}
                  {REPORT_TYPE !== 'outcomes-reported' && (
                    <Label horizontal className="blue-label">
                      {outcomeOptionsCount}
                    </Label>
                  )}
                </div>
              </div>
              <Icon name="dropdown" className="dropdown-advanced-filter" />
            </div>
          </Accordion.Title>
          {!isEmpty(state.outcomeOption) ? (
            <Accordion.Content
              active={activeIndex === 6}
              className="accordion-content"
            >
              <div>
                {isOutcomeReportedPage ? (
                  <RadioGroup
                    dataset={state.outcomeOption}
                    parentStateHandler={(value) => {
                      stateDispatch({
                        type: 'Outcome',
                        payload: value,
                      });
                      handleFilterChange({
                        outcome: getStateParentValue(value, true),
                      });
                    }}
                  />
                ) : (
                  <div>
                    {state.outcomeOptions.map((item, index) => (
                      <div key={`outcome_option_${index}`}>
                        <Checkbox
                          className="check-box"
                          label={item.text}
                          checked={item.checked}
                          onChange={(e, { checked }) => {
                            const newValue = state.outcomeOptions.map(
                              (option) =>
                                option.key === item.key
                                  ? { ...option, checked }
                                  : option
                            );
                            stateDispatch({
                              type: 'Outcomes',
                              payload: newValue,
                            });
                            handleFilterChange({
                              outcomes: getStateParentValue(newValue),
                            });
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Accordion.Content>
          ) : (
            <Accordion.Content
              active={activeIndex === 6}
              className="accordion-content"
            >
              <div>
                <p>{t('sidebar.advanced_filter.noOutcomeFound')}</p>
              </div>
            </Accordion.Content>
          )}
          {REPORT_TYPE === 'outcomes-reported' &&
            !isEmpty(state.outcomeOptions) && (
              <div id="outcome-scroll">
                <Divider className="divider-margin" />

                <Accordion.Title
                  active={activeIndex === 10}
                  className="accordion-title"
                  index={10}
                  onClick={handleClick}
                >
                  <div className="btn-flex">
                    <label className="filter-label">
                      {t('admin.evaluation_methods.method')}
                    </label>
                    <div className="filter-reset-flex">
                      <div className="open-method"></div>
                    </div>
                    <Icon
                      name="dropdown"
                      className="dropdown-advanced-filter"
                    />
                  </div>
                </Accordion.Title>
                {!isEmpty(state.methodOptions) ? (
                  <Accordion.Content
                    active={activeIndex === 10}
                    className="accordion-content"
                  >
                    <RadioGroup
                      dataset={state.methodOptions}
                      parentStateHandler={(value) => {
                        stateDispatch({
                          type: 'Methods',
                          payload: value,
                        });
                        handleFilterChange({
                          method: getStateParentValue(value, true),
                        });
                      }}
                    />
                  </Accordion.Content>
                ) : (
                  <Accordion.Content
                    active={activeIndex === 10}
                    className="accordion-content"
                  >
                    <div>
                      <p>{t('sidebar.advanced_filter.noMethodsFound')}</p>
                    </div>
                  </Accordion.Content>
                )}
              </div>
            )}
          {/* <div id="outcome-scroll">
            {REPORT_TYPE === 'outcomes-reported' &&
              !isEmpty(state.outcomeOptions) && (
                <div>
                  <Divider className="divider-margin" />
                  <label className="filter-label">Method</label>
                </div>
              )}
          </div> */}

          <Divider className="divider-margin" />

          {/* Goal */}
          {!props.isProgram && (
            <>
              <Accordion.Title
                active={activeIndex === 7}
                className="accordion-title"
                index={7}
                onClick={handleClick}
              >
                <div className="btn-flex">
                  <label className="filter-label">{t('common.goal')}</label>
                  <div className="filter-reset-flex">
                    <div className="open-goal">
                      {activeIndex === 7 && goalsOptionsCount !== 0 && (
                        <Label
                          horizontal
                          className="orange-reset"
                          onClick={(event) => {
                            filterReset(state.goalsOptions, 'Goals', event);
                            handleFilterChange(
                              {
                                goals: [],
                              },
                              event
                            );
                          }}
                        >
                          {t('actions.clear')}
                        </Label>
                      )}
                      <Label horizontal className="blue-label">
                        {goalsOptionsCount}
                      </Label>
                    </div>
                  </div>
                  <Icon name="dropdown" className="dropdown-advanced-filter" />
                </div>
              </Accordion.Title>
              {!isEmpty(state.goalsOptions) ? (
                <Accordion.Content
                  active={activeIndex === 7}
                  className="accordion-content"
                >
                  <div>
                    {state.goalsOptions.map((item, index) => (
                      <div key={`goals_option_${index}`}>
                        <Checkbox
                          className="check-box"
                          label={item.text}
                          checked={item.checked}
                          onChange={(e, { checked }) => {
                            const newValue = state.goalsOptions.map((option) =>
                              option.key === item.key
                                ? { ...option, checked }
                                : option
                            );
                            stateDispatch({
                              type: 'Goals',
                              payload: newValue,
                            });
                            handleFilterChange({
                              goals: getStateParentValue(newValue),
                            });
                            !isEmpty(getStateParentValue(newValue))
                              ? dispatch(
                                  getCrossReferenceByGoal(
                                    getStateParentValue(newValue)
                                  )
                                )
                              : stateDispatch({
                                  type: 'CrossReference',
                                  payload: [],
                                });
                            advancedFilterReset(REPORT_TYPE, 'crossReferences');
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </Accordion.Content>
              ) : (
                <Accordion.Content
                  active={activeIndex === 7}
                  className="accordion-content"
                >
                  <div>
                    <p>{t('common.no_goals_found')}</p>
                  </div>
                </Accordion.Content>
              )}
              <Divider className="divider-margin" />
            </>
          )}

          {!isEmpty(state.crossReferenceOptions) && (
            <>
              <Accordion.Title
                active={activeIndex === 8}
                index={8}
                className="accordion-title"
                onClick={handleClick}
              >
                <div className="btn-flex">
                  <label className="filter-label">
                    {t('sidebar.advanced_filter.crossReference')}
                  </label>
                  <div className="filter-reset-flex">
                    <div className="open-cross-ref">
                      {activeIndex === 8 &&
                        crossReferenceOptionsCount !== 0 && (
                          <Label
                            horizontal
                            className="orange-reset"
                            onClick={(event) => {
                              filterReset(
                                state.crossReferenceOptions,
                                'CrossReference',
                                event
                              );
                              handleFilterChange(
                                {
                                  crossReferences: [],
                                },
                                event
                              );
                            }}
                          >
                            {t('actions.clear')}
                          </Label>
                        )}
                      <Label horizontal className="blue-label">
                        {crossReferenceOptionsCount}
                      </Label>
                    </div>
                  </div>
                  <Icon name="dropdown" className="dropdown-advanced-filter" />
                </div>
              </Accordion.Title>

              <Accordion.Content
                active={activeIndex === 8}
                className="accordion-content"
              >
                <div>
                  {state.crossReferenceOptions.map((item, index) => (
                    <div key={`cross_reference_option_${index}`}>
                      <Checkbox
                        className="check-box"
                        label={item.text}
                        checked={item.checked}
                        onChange={(e, { checked }) => {
                          const newValue = state.crossReferenceOptions.map(
                            (option) =>
                              option.key === item.key
                                ? { ...option, checked }
                                : option
                          );
                          stateDispatch({
                            type: 'CrossReference',
                            payload: newValue,
                          });
                          handleFilterChange({
                            crossReferences: getStateParentValue(newValue),
                          });
                        }}
                      />
                    </div>
                  ))}
                </div>
              </Accordion.Content>
              <Divider className="divider-margin add-padding" />
            </>
          )}

          {/* Dept Hierarchy */}
          {!isEmpty(state.departmentHierarchyOptions) && (
            <>
              <Accordion.Title
                active={activeIndex === 10}
                index={10}
                className="accordion-title"
                onClick={handleClick}
              >
                <div className="btn-flex">
                  <label className="filter-label">
                    {departmentLabels?.[0]?.plural || ''}
                  </label>
                  <div className="filter-reset-flex">
                    <div className="open-department">
                      {activeIndex === 10 &&
                        departmentHierarchyOptionsCount > 0 && (
                          <Label
                            horizontal
                            className="orange-reset"
                            onClick={(event) =>
                              onClearDepartmentHierarchy(event)
                            }
                          >
                            {t('actions.clear')}
                          </Label>
                        )}
                      <Label horizontal className="blue-label">
                        {departmentHierarchyOptionsCount}
                      </Label>
                    </div>
                  </div>
                  <Icon name="dropdown" className="dropdown-advanced-filter" />
                </div>
              </Accordion.Title>
              <Accordion.Content
                active={activeIndex === 10}
                className="accordion-content dept-hierarchy"
              >
                <div>
                  {state.departmentHierarchyOptions.map((item, index) => (
                    <div key={`department_hierarchy_option_${index}`}>
                      <Checkbox
                        className={`check-box level-${item.level}`}
                        label={item.text}
                        checked={item.checked}
                        onChange={(e, { checked }) =>
                          onClickDepartmentHierarchy(item, checked, e)
                        }
                      />
                    </div>
                  ))}
                </div>
              </Accordion.Content>
              <Divider className="divider-margin" />
            </>
          )}
        </Accordion>
      </div>
    </div>
  );
};

export default withTranslation()(AdvancedActivityFilter);
